import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './learn_more.less'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/common/learn_more')

class Alert extends React.Component {
  static propTypes = {
    showArrow: PropTypes.bool,
  }

  render() {
    return (
      <div styleName="learn-more">
        <a data-pa-click="faq" href={`${GLOBAL_CONSTS.REQUEST_URI}/faq`}>
          {i18n('learn_more')}
          &nbsp;
          {this.props.showArrow && (
            <span
              styleName="learn-more-arrow"
              className="vx_icon vx_icon-small vx_icon-arrow-right-small"
            />
          )}
        </a>
      </div>
    )
  }
}

export default cssModules(Alert, styles)
